import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class SmartFeedPreview extends BaseOption {
  static userInterfaceComponent = {
    label: "Preview",
    canSetAsVariable: false,
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Yes",
          value: "yes",
        },
        {
          label: "No",
          value: "no",
        },
      ],
    },
  };

  static defaultValue = "yes";

  static convertConfigValueToCompiledValue(configValue) {
    return configValue === "yes";
  }
}
